import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets: string[] = ['_form', 'probability', 'impact', 'score', 'riskCategory', 'riskScore']

  declare readonly impactTarget: HTMLInputElement
  declare readonly probabilityTarget: HTMLInputElement
  declare readonly scoreTarget: HTMLElement
  declare readonly riskCategoryTarget: HTMLElement
  declare readonly riskScoreTarget: HTMLElement
  riskId: number | null = null

  async connect (): Promise<void> {
    const submitButton = document.getElementById('submit-risk-assessment')
    if (submitButton != null) {
      submitButton.addEventListener('click', () => {
        const impact = parseInt(this.impactTarget.value)
        const probability = parseInt(this.probabilityTarget.value)

        const form = this.element as HTMLElement
        form.dataset.turbo = isNaN(impact) || isNaN(probability) ? 'true' : 'false'
      })
    }

    const pathSegments = window.location.pathname.split('/')
    this.riskId = Number(pathSegments[2])
    await this.updateScore()
  }

  async updateScore (): Promise<void> {
    await this.fetchRiskColor()
  }

  async fetchRiskColor (): Promise<void> {
    try {
      if (this.riskId === null) {
        throw new Error('Risk ID is null')
      }

      const impact: number = parseInt(this.impactTarget.value)
      const probability: number = parseInt(this.probabilityTarget.value)

      const response = await fetch(`/risks/${this.riskId}/assessments/risk_color?impact=${impact}&probability=${probability}`)

      if (!response.ok) {
        throw new Error('Failed to fetch risk color data')
      }

      const data: { severity_level?: string, color?: string, value?: number } = await response.json()

      if (typeof data.severity_level === 'string' && typeof data.color === 'string') {
        this.scoreTarget.textContent = String(data.value)
        this.riskCategoryTarget.textContent = `${data.severity_level}:`
        this.riskScoreTarget.className = `${this.getBaseClasses()} ${data.color}`
      } else {
        this.resetRiskInfo()
      }
    } catch (error) {
      this.resetRiskInfo()
    }
  }

  resetRiskInfo (): void {
    this.scoreTarget.textContent = ''
    this.riskCategoryTarget.textContent = 'Very Low: 0'
    this.riskScoreTarget.className = `${this.getBaseClasses()} bg-stm-teal-tinted`
  }

  getBaseClasses (): string {
    return 'flex items-center px-4 py-2 space-x-1 rounded-lg h-full'
  }
}
